enum Status {
    IDLE,
    LOADING,
    ERROR
}

export default Status;
